import React, { FC, useCallback } from 'react';

import GroupChannelListHeader from '@sendbird/uikit-react/GroupChannelList/components/GroupChannelListHeader';
import { FormikProps } from 'formik';
import { Box } from '@mui/system';

import GroupChannelListTitle from '../../../Admin/ChatWindow/GroupChannelListTitle';
import CustomTextField from '../../CustomTextField';
import strings from '../../../../localization';

import ChatHeaderSearchStates from './ChatHeaderSearchStates';
import styles from './styles';

interface IGroupHeaderSearch {
  showDialog?: (() => void) | null;
  formik: FormikProps<any>;
  customMiddle?: () => JSX.Element;
}

const GroupHeaderSearch: FC<IGroupHeaderSearch> = ({
  showDialog,
  formik,
  customMiddle,
}) => {
  const { searchText, showSearch } = formik.values ?? {};

  const onSearchClick = () => {
    if (showSearch) {
      formik.resetForm();
      return;
    }
    formik.setFieldValue('showSearch', !showSearch);
  };

  const placeholder = strings.formatString(
    strings.enterCred,
    `${strings.name}/${strings.email}`,
  ) as string;

  const HeaderRight = useCallback(
    () =>
      (
        <ChatHeaderSearchStates
          searchText={searchText}
          showSearch={showSearch}
          showDialog={showDialog}
          onSearchClick={onSearchClick}
        />
      ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [searchText, showSearch],
  );

  return (
    <Box>
      <GroupChannelListHeader
        renderMiddle={customMiddle ?? GroupChannelListTitle}
        renderRight={HeaderRight}
      />
      {showSearch && (
        <CustomTextField
          customClass={styles.searchField}
          name="searchText"
          id="searchText"
          formik={formik}
          placeholder={placeholder}
        />
      )}
    </Box>
  );
};

export default GroupHeaderSearch;
